import { Component, PropTypes } from 'react';
import InlineSvg from 'svg-inline-react';
import classnames from 'classnames';

const COLOR_GRAY_DARK = '#9A9A9A';


class SVGButton extends Component {
  static propTypes = {
    hoverBackgroundColor: PropTypes.string.isRequired,
    svgString: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
    label: PropTypes.string
  }

  state = {
    isHover: false
  }

  constructor(props) {
    super(props);
    // save both svgStrings
    this.defaultSvgString = this.props.svgString.replace(/FILL_COLOR/g, COLOR_GRAY_DARK);
    this.hoverSvgString = this.props.svgString
      .replace(/FILL_COLOR/g, this.props.hoverBackgroundColor);
  }

  getColor() {
    if (this.state.isHover) {
      return this.props.hoverBackgroundColor;
    } else {
      return COLOR_GRAY_DARK;
    }
  }

  getIconSrc() {
    if (this.state.isHover) {
      return this.hoverSvgString;
    } else {
      return this.defaultSvgString;
    }
  }

  render() {
    const { onClick, className, label } = this.props;
    return (
      <span style={{color: this.getColor()}}
        onMouseEnter={() => this.setState({ isHover: true })}
        onMouseLeave={() => this.setState({ isHover: false })}
        onClick={onClick}>
        <InlineSvg className={classnames('svg-button', className)}
          src={this.getIconSrc()} />
        {label ? label : null}
      </span>
    )
  }
}

export default SVGButton;



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/SVGButton.js